module.exports = __webpack_public_path__ + "img/icon-txt.9b45b081.png";